import { useMerchant } from "@/hooks/useMerchant";
import { useTRPC } from "@/trpc/client";
import { useMemo } from "react";
import { mapPayoutStatus } from "../mappers/payouts.mapper";
import type { PayoutsFiltersType } from "../types/payouts.type";
import { useQuery } from "@tanstack/react-query";

export function useFetchPayouts(
  batchId: string,
  filters: PayoutsFiltersType = {},
  cursor?: string
) {
  const trpc = useTRPC();
  const { merchant } = useMerchant();

  const queryInput = useMemo(
    () => ({
      rentalsMerchantId: merchant?.id ?? "",
      batchId: batchId,
      cursor,
      statuses:
        filters.status &&
        mapPayoutStatus[filters.status as keyof typeof mapPayoutStatus]
          ? [mapPayoutStatus[filters.status as keyof typeof mapPayoutStatus]]
          : undefined,
      id: filters.id && filters.id.trim() !== "" ? filters.id : undefined,
      customerDocumentNumber:
        filters.customerDocumentNumber &&
        filters.customerDocumentNumber.trim() !== ""
          ? filters.customerDocumentNumber
          : undefined,
    }),
    [merchant?.id, batchId, cursor, filters]
  );

  const { data, isLoading } = useQuery(
    trpc.payouts.list.queryOptions(queryInput, {
      enabled: !!merchant?.id && !!batchId,
    })
  );

  const items = data?.data || [];
  const nextCursor = data?.cursor || undefined;

  return { items, nextCursor, isLoading };
}
